namespace TabAurous.Stock {
    export namespace MetalMovementService {
        export const baseUrl = 'Stock/MetalMovement';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/MetalMovement/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>MetalMovementService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
